<template>
  <div id="app">
      <header-main
              :form_open="is_form_open"
                @toggleForm="toggleForm($event)"
      ></header-main>
    <router-view/>
      <sign-in-form
              v-if="is_form_open"
              @close="is_form_open = false"
      ></sign-in-form>
  </div>
</template>

<style lang="scss">
  @import './styles/main.scss';
</style>
<script>
    import HeaderMain from './components/Header/HeaderMain';
    import SignInForm from "./components/Forms/SignInForm";
    export default {
        components: {SignInForm, HeaderMain },
        data() {
            return {
                is_form_open: false
            }
        },
        methods: {
            toggleForm(val) {
                this.is_form_open = val;
            }
        }
    };
</script>
